// @flow

import React, { createContext } from 'react';
import type { HOC as ElementType } from 'recompose';

export const TransactionContext: any = createContext({
  contextState: {},
  contextActions: {},
});

export const withConsumer = (Comp: ElementType) => (props: any) => (
  <TransactionContext.Consumer>
    {context => <Comp {...Object.assign({}, context, props)} />}
  </TransactionContext.Consumer>
);
